import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = `rewards`;
  const { match } = props;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [name, setName] = useState(``);
  const [rate, setRate] = useState(``);
  const [voucher, setVoucher] = useState(``);
  const [submitted, setSubmitted] = useState(false);
  const [description, setDescription] = useState(``);
  const [image, setImage] = useState(``);
  const [state, setState] = useState(``);

  const [id, setId] = useState();
  const params = useParams()
  const navigate = useNavigate()



  const handleAboutChange = (value) => setDescription(value);
  const handleChangeState = (value) => setState(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.rewards_store != undefined && appReducer.rewards_store.error == false) ||
        (appReducer.rewards_update != undefined && appReducer.rewards_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.rewards_store,
    appReducer.rewards_update
  ])


  useEffect(() => {
    if (appReducer.rewards_edit != undefined && id != undefined) {
      let row = appReducer.rewards_edit.data;
      setName(row.name);
      setDescription(row.description)
      setRate(row.rate);
      setVoucher(row.voucher);
      setImage(row.image_full)
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.rewards_edit]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
    dispatch(actions.list(`provinces/option`));
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return (
    <Row>
      <Template.Card col="col-md-6 col-xs-12 col-sm-12" title={props.page}>
        <Template.Form>
          <Template.Input
            required
            value={name}
            label="نام"
            name="name"
            type="text"
          />
          <Template.Input
            required
            value={rate}
            label="امتیاز مورد نیاز"
            name="rate"
            type="text"
          />
           <Template.Input
            required
            value={voucher}
            label="کد تخفیف"
            name="voucher"
            type="text"
          />
           <Template.FileInput
          required
            deleteUrl="rewards/destroy_image"
            name="image"
            rowId={id}
            value={image && [image]}
            label="تصویر"
          />
          <div>
            <EditorField
              label="توضیحات"
              onEditorChange={handleAboutChange}
              value={description}
            />
            <input name="description" type="hidden" defaultValue={description} />
          </div>
          <Template.SingleSelect
            withLabel
            required
            placeholder="وضعیت"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "active",
                label: "فعال",
              },
              {
                value: "deactive",
                label: "غیرفعال",
              },
            ]}
          />
          <Template.Button
            label="ذخیره"
            
            onClick={handleClick}
          />
        </Template.Form>
      </Template.Card>
    </Row>
  );
};